<template>
<div>
    <b-container>
        <b-row>
            <b-col col sm="12">
                <b-card no-body>
                    <b-col sm="4" v-if="hasMedecinControleRole || hasPraticienRole || hasAdminRole">
                        <select id="singleMotif" class="mt-3" v-model="filteredValue">
                            <option data-placeholder="true"></option>
                            <option v-for="item in filtered" :key="item.id" :value="item.id">
                                {{ item.text }}
                            </option>
                        </select>
                        
                    </b-col>
                    <b-tabs card content-class="mt-3" fill active-nav-item-class="font-weight-bold text-uppercase text-success">
                        <b-tab no-body :title="$t('message.infoPatient')" id="tab1">
                            <b-card-body>
                                <div>
                                    <b-row>

                                        <b-col col sm="12">
                                            <h3 class="text-center">{{ $tc('message.patients',1) }}</h3>

                                            <p>
                                                {{ $t('message.name') }}:
                                                <span class="font-weight-bold">{{ nom }}</span>
                                            </p>

                                            <p>
                                                {{ $t('message.fileNumber') }}:
                                                <span class="font-weight-bold">{{ getMedicalValue('numero_dossier')}}</span>
                                            </p>

                                            <p>
                                                {{ $t('message.email') }}:
                                                <span class="font-weight-bold">{{getUserValue('email')}}</span>
                                            </p>
                                        </b-col>
                                       
                                        <b-col col sm="12">
                                            <h3 class="text-center">{{ $tc('message.medecinReferent',1) }}
                                            </h3>
                                                 <div>
                                                    <b-row class="mt-1">
                                                        <b-col md="6" sm="6">
                                                            <b-form-group
                                                                    id="responsable-group"
                                                                    label-for="responsable">
                                                                <!-- Options -->
                                                                <select
                                                                        required
                                                                        multiple
                                                                        id="responsable"
                                                                        v-model="$v.form.responsable.$model"
                                                                        class="form-control is-invalid border-light retirerBordure"
                                                                >
                                                                    <option v-for="item in mDoctors" :value="item.id" :key="item.id">
                                                                        {{ item.nom }}
                                                                    </option>
                                                                </select>

                                                                <b-form-invalid-feedback v-if="errorshasField('responsable')">
                                                                    {{ getErrorsField('responsable') }}
                                                                </b-form-invalid-feedback>

                                                            </b-form-group>
                                                         
                                                        </b-col>
                                                        <b-col md="6" sm="6">
                                                            <b-link class="ml-2" @click="onAddReferent" variant="primary">
                                                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.add', 1) }}
                                                            </b-link> 
                                                        </b-col> 
                                                    </b-row>
                                            </div>
                                            <template v-if="mReferentDoctors.length > 0">
                                                <div v-for="item in mReferentDoctors" :key="item.id">
                                                <hr />
                                                <div class="row">
                                                    <div class="col col-md-4">
                                                        {{ $t('message.medecin') }}
                                                        <p class="font-weight-bold">{{ item.nom }}</p>
                                                    </div>

                                                    <div class="col col-md-2">
                                                        {{ $t('message.phone') }}
                                                        <p class="font-weight-bold">{{ item.phone }}</p>
                                                    </div>

                                                    <div class="col col-md-4">
                                                        {{ $t('message.email') }}
                                                        <p class="font-weight-bold">{{ item.email }}</p>
                                                    </div>
                                                    <div class="col col-md-2">
                                                        {{ $t('message.action') }}
                                                        <b-link class="ml-4" style="color:red" @click="removeReferent(item)" variant="primary" >
                                                                <i class="fas fa-delete edit-icon" style="color:red"></i> {{ $tc('message.delete', 1) }}
                                                        </b-link> 
                                                    </div>
                                                </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <h1>
                                                        aucun medecin
                                                    </h1>
                                                </div>
                                            </template>
                                            <hr />
                                        </b-col>
                                    </b-row>
                                </div>
                                <div v-if="hasAdminRole || hasMedecinControleRole">
                                    <hr>

                                    <h3 class="text-center">{{ $tc('message.subscribers',1) }}</h3>

                                    <p>
                                        {{ $t('message.name') }}:
                                        <span class="font-weight-bold"> {{getSouscripteurValue('nom').toUpperCase()}} {{ getSouscripteurValue('prenom').charAt(0).toUpperCase() + getSouscripteurValue('prenom').substring(1)}}</span>
                                    </p>

                                    <p>
                                        {{ $t('message.email') }}:
                                        <span class="font-weight-bold">{{getSouscripteurValue('email')}}</span>
                                    </p>

                                    <p>
                                        {{ $t('message.phoneNumber') }}:
                                        <span class="font-weight-bold">{{getSouscripteurValue('telephone')}}</span>
                                    </p>
                                </div>
                                <hr>
                                <div>
                                    <b-row>
                                        <b-col col sm="12" v-if="hasAdminRole ||  hasPraticienRole || hasMedecinControleRole">
                                            <b-dropdown id="dropdown-left" :text="$tc('message.addConsultation')" variant="link" class="m-2" no-caret v-if="hasAdminRole ||  hasPraticienRole || hasMedecinControleRole">
                                                <b-dropdown-item :to="{ name: 'add-consultation-manuscrit' , params: { file: this.file_id } }">{{$t('message.manuscrit')}}</b-dropdown-item>
                                                <b-dropdown-item v-if="isFemale" :to="{ name: 'add-consultation-obstetric', params: { file: this.file_id } }">{{$t('message.obstetric')}}</b-dropdown-item>
                                                <b-dropdown-item :to="{ name: 'add-consultation-general' , params: { file: this.file_id } }">{{$t('message.general')}}</b-dropdown-item>
                                                <b-dropdown-item :to="{ name: 'add-consultation-cardiology' , params: { file: this.file_id } }">{{$t('message.cardiology')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.dermatology')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.endocrinology')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.gastroenterology')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.geriatrics')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.hématologie')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.nephrology')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.neurology')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.ophthalmology')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.oncology')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.earNoseThroat')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.pediatrics')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.pneumology')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.psychiatry')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.rheumatology')}}</b-dropdown-item>
                                                <b-dropdown-item href="#">{{$t('message.stomatology')}}</b-dropdown-item>
                                            </b-dropdown>

                                            <b-link variant="primary" @click="toAllergie">
                                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.allergies', 1) }}
                                            </b-link>
                                            <!--                                                <br>-->
                                            <b-link class="ml-4" variant="primary" @click="toAntecedent">
                                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.antecedents', 1) }}
                                            </b-link>
                                            <!--                                                <br>-->
                                            <!--                                                <b-link class="ml-4" :to="{ name: 'add-consultation-obstetric', params: { file: this.file_id } }" variant="primary" v-if="isFemale">-->
                                            <!--                                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.obstetricConsultations', 1) }}-->
                                            <!--                                                </b-link>-->
                                            <!--                                                <b-link class="ml-4" :to="{ name: 'add-consultation-general' , params: { file: this.file_id } }" variant="primary">-->
                                            <!--                                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.generalConsultations', 1) }}-->
                                            <!--                                                </b-link>-->
                                            <!--                                                <b-link class="ml-4" :to="{ name: 'add-consultation-cardiology', params: { file: this.file_id } }" variant="primary">-->
                                            <!--                                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.cardiologyConsultations') }}-->
                                            <!--                                                </b-link>-->
                                            <!--                                                <br>-->
                                            <b-link class="ml-4" :to="{ name: 'add-treatments', params: { file: this.file_id } }" variant="primary">
                                                <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.currentTreatments') }}
                                            </b-link>
                                            <b-link class="mr-2" :to="{ name: 'add-lab-result' , params: { file: this.file_id }}" variant="primary">
                                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.labResults',2) }}
                                            </b-link>
                                            <!--                                                <br>-->
                                            <b-link class="ml-4 mr-2" :to="{ name: 'add-imagery-result' , params: { file: this.file_id }}" variant="primary">
                                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.imageryResults',2) }}
                                            </b-link>
                                            <!--                                                <br>-->
                                            <b-link class="ml-5" :to="{ name: 'add-hospitalisation', params: { file: this.file_id } }" variant="primary">
                                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.hospitalisations',2) }}
                                            </b-link>

                                        </b-col>
                                    </b-row>
                                </div>

                            </b-card-body>
                        </b-tab>

                        <b-tab no-body :title=" $tc('message.allergies',1)" :active="pathHas($tc('message.allergies',1))">

                            <b-link class="ml-4" variant="primary" @click="toAllergie" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole">
                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.allergies', 1) }}
                            </b-link>

                            <b-card-body>
                                <vue-good-table id="allergie" v-if="notEmpty(allergiesRows)" :columns="allergiesColumns" :rows="allergiesRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onAllergieRowClick" />
                            </b-card-body>

                        </b-tab>

                        <b-tab no-body :title=" $tc('message.antecedents',2) " :active="pathHas($tc('message.antecedents',2))">

                            <b-link class="ml-4" variant="primary" @click="toAntecedent" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole">
                                <i class="fas fa-plus-circle edit-icon"></i>{{ $tc('message.antecedents', 1) }}
                            </b-link>

                            <b-card-body>
                                <vue-good-table id="antecedent" v-if="notEmpty(antecedentsRows)" :columns="antecedentsColumns" :rows="antecedentsRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onAntecedentRowClick" />
                            </b-card-body>

                        </b-tab>

                        <b-tab no-body :title="$tc('message.consultations',2)" :active="pathHas('generale') || pathHas('obstetric') || pathHas('cardiologie')">
                            <b-row>
                                <b-col sm="4">
                                    <b-dropdown id="dropdown-left" :text="$tc('message.addConsultation')" variant="primary" class="m-2" v-if="hasAdminRole ||  hasPraticienRole || hasMedecinControleRole">
                                        <b-dropdown-item v-if="isFemale" :to="{ name: 'add-consultation-obstetric', params: { file: this.file_id } }">{{$t('message.obstetric')}}</b-dropdown-item>
                                        <b-dropdown-item :to="{ name: 'add-consultation-general' , params: { file: this.file_id } }">{{$t('message.general')}}</b-dropdown-item>
                                        <b-dropdown-item :to="{ name: 'add-consultation-cardiology' , params: { file: this.file_id } }">{{$t('message.cardiology')}}</b-dropdown-item>
                                        <b-dropdown-item :to="{ name: 'add-consultation-kinesitherapie' , params: { file: this.file_id } }">{{$t('message.kinesitherapie')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.dermatology')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.endocrinology')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.gastroenterology')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.geriatrics')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.hématologie')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.nephrology')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.neurology')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.ophthalmology')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.oncology')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.earNoseThroat')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.pediatrics')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.pneumology')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.psychiatry')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.rheumatology')}}</b-dropdown-item>
                                        <b-dropdown-item href="#">{{$t('message.stomatology')}}</b-dropdown-item>
                                    </b-dropdown>
                                </b-col>

                                <b-col sm="4"></b-col>
                            </b-row>
                            <div id="generale" v-if="notEmpty(medecinesRows)">
                                <h3 class="text-center"> {{ $tc('message.generalConsultations', 1) }}</h3>

                                <b-card-body>
                                    <vue-good-table v-if="notEmpty(medecinesRows)" id="medecine" :columns="medecinesColumns" :rows="medecinesRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onMedecineRowClick" />
                                </b-card-body>
                            </div>

                            <div id="obstetric" v-if="isFemale && notEmpty(obstetricsRows)">
                                <h3 class="text-center"> {{ $tc('message.obstetricConsultations', 1) }}</h3>
                                <b-card-body>
                                    <vue-good-table v-if="notEmpty(obstetricsRows)" :columns="obstetricsColumns" :rows="obstetricsRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onObsteticRowClick" />
                                </b-card-body>
                            </div>

                            <div id="cardiologie" v-if="notEmpty(cardiologiesRows)">
                                <h3 class="text-center"> {{ $t('message.cardiologyConsultations') }}</h3>
                                <b-card-body>

                                    <vue-good-table v-if="notEmpty(cardiologiesRows)" id="cardiologie_consultation" :columns="cardiologiesColumns" :rows="cardiologiesRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onCardiologyRowClick" />
                                </b-card-body>
                            </div>
                            <div id="kinesitherapie" v-if="notEmpty(kinesitherapiesRows)">
                                <h3 class="text-center"> {{ $t('message.kinesitherapyConsultations') }}</h3>
                                <b-card-body>

                                    <vue-good-table v-if="notEmpty(kinesitherapiesRows)" id="kinesitherapie_consultation" :columns="kinesitherapiesColumns" :rows="kinesitherapiesRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onkinesitherapyRowClick" />
                                </b-card-body>
                            </div>
                        </b-tab>

                        <b-tab :title="$t('message.currentTreatments')" :active="pathHas('traitement')">

                            <b-link class="ml-4" :to="{ name: 'add-treatments', params: { file: this.file_id } }" variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole">
                                <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.currentTreatments') }}
                            </b-link>

                            <b-card-body>
                                <vue-good-table id="traitement" :columns="traitementsColumns" :rows="traitementsRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onTraitementRowClick" />
                            </b-card-body>
                        </b-tab>

                        <b-tab :title="$tc('message.prescriptions',2)" :active="pathHas($tc('message.prescriptions',2))">

                            <b-link class="ml-4" :to="{ name: 'add-prescription' }" variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole">
                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.prescriptions',1) }}
                            </b-link>

                            <b-card-body>
                                <vue-good-table id="prescriptions" :columns="prescriptionsColumns" :rows="prescriptionsRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onPrescriptionRowClick" />
                            </b-card-body>
                        </b-tab>

                        <b-tab :title="$tc('message.results',2)" :active="pathHas('resultatLabo') || pathHas('resultatImagerie') ">
                            <div id="resultatLabo">
                                <h3 class="text-center"> {{ $tc('message.labResults', 2) }}</h3>
                                <b-link class="ml-4" :to="{ name: 'add-lab-result' , params: { file: this.file_id }}" variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole">
                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.labResults',2) }}
                                </b-link>

                                <b-card-body>
                                    <vue-good-table v-if="notEmpty(mResultatsLabo)" id="labResult" :columns="labResultsColumns" :rows="labResultsRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onLabResultRowClick" />
                                </b-card-body>
                            </div>
                            <div id="resultatImagerie">
                                <h3 class="text-center"> {{ $tc('message.imageryResults', 2) }}</h3>

                                <b-link class="ml-4 mr-2" :to="{ name: 'add-imagery-result' , params: { file: this.file_id }}" variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole">
                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.imageryResults',2) }}
                                </b-link>

                                <b-card-body>
                                    <vue-good-table v-if="notEmpty(mResultatsImagerie)" id="imgResult" :columns="imgResultsColumns" :rows="imgResultsRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onImgResultRowClick" />
                                </b-card-body>
                            </div>

                        </b-tab>

                        <b-tab :title="$tc('message.hospitalisations',1)" :active="pathHas($tc('message.hospitalisations',1))">

                            <b-link class="ml-4" :to="{ name: 'add-hospitalisation' }" variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole">
                                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.hospitalisations',2) }}
                            </b-link>

                            <b-card-body>
                                <vue-good-table id="hospitalisation" v-if="notEmpty(hospitalisationsRows)" :columns="hospitalisationsColumns" :rows="hospitalisationsRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onHospitalisationRowClick" />
                            </b-card-body>
                        </b-tab>

                        <b-tab :title="$tc('message.medicalAdvice',1)" v-if="can" :active="pathHas($tc('message.medicalAdvice',1))">
                            <b-card-body>
                                <div v-if="mMedicalAdvices.length > 0" class="timeline">
                                    <div class="timeline-month">
                                        {{ $t('message.medicalAdvice') }} {{ $t('message.validated') }}
                                    </div>
                                    <div v-for="(medicalAdvice, key) in mMedicalAdvices" :key="key">
                                        <!--                                            v-if="medicalAdvice.avis"-->
                                        <div class="timeline-section">
                                            <div class="timeline-date">
                                                {{ displayDate(medicalAdvice.medecin_avis[0].set_opinion_at) }}
                                            </div>
                                            <div class="row">
                                                <div v-for="(adviceDoctor, keyG) in medicalAdvice.medecin_avis" :key="keyG" class="col-md-10 col-sm-6">
                                                    <div class="timeline-box">
                                                        <div class="box-title">
                                                            <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                            {{adviceDoctor.medecin.nom + ' ' + adviceDoctor.medecin.prenom}}
                                                        </div>
                                                        <div class="box-content">
                                                            <div class="box-item row">
                                                                <p class="box-item-label col-md-3">
                                                                    {{ $t('message.description') }}
                                                                </p>
                                                                <p class="box-item-content col-md-9" v-html="medicalAdvice.description">
                                                                </p>
                                                            </div>
                                                            <div class="box-item row">
                                                                <p class="box-item-label col-md-3">
                                                                    {{ `${$t('message.response')}` }}
                                                                    <!--                                                                        <span>{{ adviceDoctor.medecin.nom + ' ' + adviceDoctor.medecin.prenom }}</span>-->
                                                                </p>
                                                                <p class="box-item-content col-md-9" v-html="adviceDoctor.avis">
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <p v-else class="mt-2">
                                    <i>{{ $t('message.noResponseOfMedicalAdviceValidated') }}</i>
                                </p>
                            </b-card-body>
                        </b-tab>
                        <b-tab no-body :title="$t('message.fichiersExternes')" :active="pathHas('fichiersExternes') ">
                            <div id="manuscrit">
                                <h3 class="text-center"> {{ $t('message.manuscritConsultations') }}</h3>
                                <b-link class="ml-4" variant="primary" @click="toManuscrit" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole">
                                    <i class="fas fa-plus-circle edit-icon"></i>{{ $t('message.manuscrit') }}
                                </b-link>
                                <b-card-body>
                                    <vue-good-table v-if="notEmpty(manuscritRows)" :columns="manuscritColumns" :rows="manuscritRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onManuscritRowClick" />
                                </b-card-body>
                            </div>
                        </b-tab>
                        <b-tab no-body :title="$t('message.compteRenduOperatoire')" :active="pathHas('compteRenduOperatoire') ">
                            <div id="compteRenduOperatoire">
                                <h3 class="text-center"> {{ $t('message.compteRenduOperatoire') }}</h3>
                                <b-link class="ml-4" variant="primary" @click="toCompteRendu" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole">
                                    <i class="fas fa-plus-circle edit-icon"></i>{{ $t('message.compteRenduOperatoire') }}
                                </b-link>
                                <b-card-body>
                                    <vue-good-table v-if="notEmpty(comptesRenduOpRows)" :columns="comptesRenduOpColumns" :rows="comptesRenduOpRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onComptesRenduOpRowClick" />
                                </b-card-body>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import SlimSelect from "slim-select";
import moment from "moment";

export default {
    name: "MedicalFile",

    computed: {
        ...mapGetters(["file",
            'hasAdminRole',
            'hasGestionnaireRole',
            'hasPraticienRole',
		    "controlDoctors",            
            'hasMedecinControleRole',
            'hasSouscripteurRole',
            'hasPatientRole',
            "medicalAdvices"
        ]),

        can: function () {
            return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole;
        },

        isFemale: function () {
            return this.mMedicalFile.hasOwnProperty('patient') ? this.mMedicalFile.patient.sexe == "F" : false;
        },

        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
        mReferentDoctors:{
                get: function () {
                    let dArray = [];
                    if (!_.isUndefined(this.mMedicalFile.patient)) {
                        if (!_.isUndefined(this.mMedicalFile.patient.medecin_referent)) {
                        _.forEach(this.mMedicalFile.patient.medecin_referent, function(doctor) {
                            let d = {};
                            if((typeof doctor.medecin_controles.user == 'object') && (!_.isNull(doctor.medecin_controles.user))){
                            let prenom = doctor.medecin_controles.user.prenom != null || doctor.medecin_controles.user.prenom != undefined ?  doctor.medecin_controles.user.prenom : "";
                            prenom =  prenom.toLowerCase();
                            d.nom =  (doctor.medecin_controles.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                            d.id = doctor.medecin_controles.user.id;
                            d.phone = doctor.medecin_controles.user.telephone
                            d.email = doctor.medecin_controles.user.email
                            if (d.nom.length >0){
                                dArray.push(d);
                            }
                            }

                        });
                        }
                    }
                    return dArray;
                },
                set: function(newValue){
                    this.mReferentDoctors = newValue;
                }
        },
        nom: function () {
            if (!_.isUndefined(this.mMedicalFile.patient)) {
                if (!_.isUndefined(this.mMedicalFile.patient.user)) {
                    let prenom = (this.mMedicalFile.patient.user.prenom == null) ? '' : this.mMedicalFile.patient.user.prenom;
                    return (this.mMedicalFile.patient.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                }
                return "";
            }
            return '';
        },

        mAllergies: function () {
            return (typeof this.mMedicalFile.allergies == "object" ? this.mMedicalFile.allergies : []);
        },
			mDoctors: function() {
				let dArray = [];

				_.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
					let d = {};
					if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
						let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
						prenom =  prenom.toLowerCase();
						d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
						d.id = doctor.user.id;

						if (d.nom.length >0){
							dArray.push(d);
						}
					}

				});
				return dArray;
			},
      
        mAntecedents: function () {
            let mArray = [];
            mArray = typeof this.mMedicalFile.antecedents == "object" ? this.mMedicalFile.antecedents : [];

            let cMedecines = this.mMedicalFile.consultations_medecine;
            let cCardiologies = this.mMedicalFile.cardiologies;

            _.forEach(cCardiologies, function (cardiologie) {
                if (!_.isNull(cardiologie.conclusion) && cardiologie.conclusion !== 'null') {
                    let c = {}
                    c.type = 'Consultation';
                    c.description = cardiologie.conclusion;
                    c.date = moment(cardiologie.updated_at).format('YYYY-MM-DD');
                    c.cardiology = cardiologie.slug;
                    mArray.push(c);
                }
            });

            _.forEach(cMedecines, function (medecine) {
                _.forEach(medecine.conclusions, function (conclusion) {
                    let m = {};
                    m.type = 'Consultation';
                    m.description = conclusion.description;
                    m.date = moment(conclusion.updated_at).format('YYYY-MM-DD');
                    m.medecine = medecine.slug;
                    mArray.push(m);
                })
            })

            return mArray;
        },

        mConsultationsMedecine: function () {
            return (typeof this.mMedicalFile.consultations_medecine == "object" ? this.mMedicalFile.consultations_medecine : []);
        },

        mConsultationsObstetrique: function () {
            return (typeof this.mMedicalFile.consultations_obstetrique == "object" ? this.mMedicalFile.consultations_obstetrique : []);
        },

        mEchographies: function () {
            let eArray = [];

            _.forEach(this.mConsultationsObstetrique, function (consultation) {
                _.forEach(consultation.echographies, function (echographie) {
                    eArray.push({
                        echographie: echographie,
                        consultationSlug: consultation.slug,
                        numero: consultation.numero_grossesse,
                        date: consultation.date_creation
                    });
                })
            })
            return eArray;
        },

        mHospitalisations: function () {
            return (typeof this.mMedicalFile.hospitalisations == "object" ? this.mMedicalFile.hospitalisations : []);
        },

        mTraitements: function () {
            return (typeof this.mMedicalFile.traitements == "object" ? this.mMedicalFile.traitements : []);
        },

        mResultatsImagerie: function () {
            return (typeof this.mMedicalFile.resultats_imagerie == "object" ? this.mMedicalFile.resultats_imagerie : []);
        },

        mResultatsLabo: function () {
            return (typeof this.mMedicalFile.resultats_labo == "object" ? this.mMedicalFile.resultats_labo : []);
        },

        prescriptionsRows: function () {
            return this.mMedicalFile.ordonances;
        },

        echographiesRows: function () {
            let eArray = [];
            _.forEach(this.mConsultationsObstetrique, function (consultation) {
                let oeArray = [];

                _.forEach(consultation.echographies, function (echographie) {
                    oeArray.push({
                        type: echographie.type,
                        ddr: echographie.ddr,
                        dpa: echographie.dpa,
                        semaine_amenorrhee: echographie.semaine_amenorrhee,
                        slug: echographie.slug
                    });
                });

                eArray.push({
                    mode: "span",
                    label: "Grossesse n° " + consultation.numero_grossesse,
                    html: false,
                    children: oeArray
                });
            });

            return eArray;
        },

        allergiesRows: function () {
            let aArray = [];

            _.forEach(this.mAllergies, function (allergy) {
                aArray.push({
                    description: allergy.description,
                    date: allergy.date,
                    slug: allergy.slug
                })
            })

            return aArray;
        },

        antecedentsRows: function () {

            return this.mAntecedents
        },

        comptesRenduOpRows: function () {
            let self = this;
            let cArray = [];

            _.forEach(self.mMedicalFile.comptes_rendu_operatoire, function (compte) {
                let c = {};
                let etablissement = ''
                if (!_.isNull(compte.etablissement_id)) {
                    if (compte.hasOwnProperty('etablissement')) {
                        if (!_.isNull(compte.etablissement)) {
                            etablissement = compte.etablissement.name;
                        } else {
                            etablissement = "";
                        }
                    }
                }
                c.etablissement = etablissement;
                c.type = compte.type_intervention;
                c.date = moment(compte.date_intervention).format('YYYY-MM-DD HH:mm');
                c.slug = compte.slug;
                cArray.push(c);
            });

            return cArray;
        },

        manuscritRows: function () {
            let self = this;
            let cArray = [];
            let consultationsInitiale = self.mMedicalFile.consultations_manuscrites;
            let consultations = _.orderBy(consultationsInitiale, ['id'], ['desc']);
            _.forEach(consultations, function (consultation) {
                let author = consultation.praticien;
                let fullName = '';
                if (!_.isNull(author)) {
                    let prenom = (author.prenom == null) ? '' : author.prenom;
                    fullName = (author.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                } else {
                    fullName = consultation.praticien_externe;
                }

                cArray.push({
                    'type': consultation.name == 'null' ? consultation.consultation_externe : consultation.name,
                    'etablissement': _.isNull(consultation.etablissement) ? '' : consultation.etablissement.name,
                    'praticien': fullName,
                    'date': consultation.date_consultation,
                    'slug': consultation.slug,
                });
            })

            return cArray;
        },

        medecinesRows: function () {
            let self = this;
            let mArray = [];
            _.forEach(_.orderBy(self.mConsultationsMedecine, ['created_at'], ['desc']), function (consultation) {
                let motifs = "";
                let conclusions = "";
                let etablissement = "";

                if (consultation.hasOwnProperty('motifs')) {
                    _.forEach(consultation.motifs, function (motif, key) {
                        motifs = motifs + ((key != consultation.motifs.length && key != 0) ? "," : " ") + motif.description;
                    });

                    if (motifs.length > 105) {
                        motifs = motifs.substring(0, 105) + " ...";
                    }
                }

                if (consultation.hasOwnProperty('conclusions')) {
                    _.forEach(consultation.conclusions, function (conclusion) {
                        conclusions += " " + conclusion.description;
                    });

                    if (conclusions.length > 105) {
                        conclusions = conclusions.substring(0, 105) + " ...";
                    }
                }

                if (!_.isNull(consultation.etablissement_id)) {
                    if (consultation.hasOwnProperty('etablissement')) {
                        if (!_.isNull(consultation.etablissement)) {
                            etablissement = consultation.etablissement.name;
                        } else {
                            etablissement = "";
                        }
                    }
                }

                let traitement = "";
                if (!_.isNull(consultation.traitement_propose)) {
                    if (consultation.traitement_propose.length > 105) {
                        traitement = consultation.traitement_propose.substring(0, 105) + " ...";
                    } else {
                        traitement = consultation.traitement_propose;
                    }
                }

                mArray.push({
                    date: consultation.date_consultation,
                    motifs: motifs,
                    conclusions: conclusions,
                    etablissement: etablissement,
                    traitement: traitement,
                    slug: consultation.slug,
                    consultant: self.formatFullName(consultation.author),
                    passedAt: consultation.passed_at,
                    archievedAt: consultation.archieved_at
                });
            });
            let sArray = mArray;
            mArray = self.filterResult(sArray, mArray);
            return mArray;
        },
        kinesitherapiesRows: function () {
            let kArray = [];

            let self = this;

            _.forEach(_.orderBy(self.mMedicalFile.kinesitherapies, ['created_at'], ['desc']), function (kinesitherapie) {
                let motifs = "";
                let date = "";
                let diagnostic = "";
                let etablissement = "";
                //console.log(kinesitherapie);
                if (kinesitherapie.hasOwnProperty('motifs')) {
                    _.forEach(kinesitherapie.motifs, function (motif, key) {
                        motifs = motifs + ((key != kinesitherapie.motifs.length && key != 0) ? "," : " ") + motif.description;
                    });

                    if (motifs.length > 105) {
                        motifs = motifs.substring(0, 105) + " ...";
                    }
                }
                if (!_.isNull(kinesitherapie.etablissement_id)) {
                    if (kinesitherapie.hasOwnProperty('etablissement')) {
                        if (!_.isNull(kinesitherapie.etablissement)) {
                            etablissement = kinesitherapie.etablissement.name;
                        } else {
                            etablissement = kinesitherapie.etablissement_id;
                        }
                    }
                }

                date = kinesitherapie.date_consultation;
                if (!_.isNull(kinesitherapie.impression_diagnostique)) {
                    diagnostic = (kinesitherapie.impression_diagnostique.length > 105) ? kinesitherapie.impression_diagnostique.substring(0, 105) + " ..." : kinesitherapie.impression_diagnostique;
                }

                kArray.push({
                    date: date,
                    motifs: motifs,
                    conclusions: diagnostic,
                    etablissement: etablissement,
                    slug: kinesitherapie.slug,
                    consultant: self.formatFullName(kinesitherapie.author),
                    passedAt: kinesitherapie.passed_at,
                    archievedAt: kinesitherapie.archieved_at
                });
            });

            let sArray = kArray;
            kArray = self.filterResult(sArray, kArray);
            return kArray;
        },
        cardiologiesRows: function () {
            let cArray = [];

            let self = this;

            _.forEach(_.orderBy(self.mMedicalFile.cardiologies, ['created_at'], ['desc']), function (consultation) {
                let motifs = "";
                let date = "";
                let diagnostic = "";
                let etablissement = "";

                if (consultation.hasOwnProperty('motifs')) {
                    _.forEach(consultation.motifs, function (motif, key) {
                        motifs = motifs + ((key != consultation.motifs.length && key != 0) ? "," : " ") + motif.description;
                    });

                    if (motifs.length > 105) {
                        motifs = motifs.substring(0, 105) + " ...";
                    }
                }
                if (!_.isNull(consultation.etablissement_id)) {
                    if (consultation.hasOwnProperty('etablissement')) {
                        if (!_.isNull(consultation.etablissement)) {
                            etablissement = consultation.etablissement.name;
                        } else {
                            etablissement = "";
                        }
                    }
                }

                date = consultation.date_consultation;
                if (!_.isNull(consultation.conclusion)) {
                    diagnostic = (consultation.conclusion.length > 105) ? consultation.conclusion.substring(0, 105) + " ..." : consultation.conclusion;
                }

                cArray.push({
                    date: date,
                    motifs: motifs,
                    conclusions: diagnostic,
                    etablissement: etablissement,
                    slug: consultation.slug,
                    consultant: self.formatFullName(consultation.author),
                    passedAt: consultation.passed_at,
                    archievedAt: consultation.archieved_at
                });
            });

            let sArray = cArray;
            cArray = self.filterResult(sArray, cArray);
            return cArray;
        },

        traitementsRows: function () {
            let tArray = [];

            _.forEach(this.mTraitements, function (traitement) {
                // tArray.push({date:traitement.created_at,description: traitement.description,slug:traitement.slug})
                tArray.push({
                    description: traitement.description,
                    slug: traitement.slug
                })
            });

            return tArray;
        },

        obstetricsRows: function () {
            let oArray = [];
            let self = this;
            _.forEach(this.mConsultationsObstetrique, function (consultation) {
                let etablissement = "";
                if (!_.isNull(consultation.etablissement_id)) {
                    if (consultation.hasOwnProperty('etablissement')) {
                        if (!_.isNull(consultation.etablissement)) {
                            etablissement = consultation.etablissement.name;
                        } else {
                            etablissement = "";
                        }
                    }
                }
                oArray.push({
                    numero: consultation.numero_grossesse,
                    date: consultation.ddr,
                    serologie: consultation.serologie,
                    groupe: consultation.groupe_sanguin,
                    etablissement: etablissement,
                    slug: consultation.slug,
                    consultant: self.formatFullName(consultation.author),
                    passedAt: consultation.passed_at,
                    archievedAt: consultation.archieved_at
                })
            });

            let sArray = oArray;
            oArray = self.filterResult(sArray, oArray);
            return oArray;
        },

        labResultsRows: function () {
            let lrArray = [];
            let self = this;

            _.forEach(self.mResultatsLabo, function (resultat) {
                lrArray.push({
                    description: resultat.description,
                    date: resultat.date,
                    slug: resultat.slug,
                    passedAt: resultat.passed_at,
                    archievedAt: resultat.archived_at
                });
            });
            let sArray = lrArray;
            lrArray = self.filterResult(sArray, lrArray);
            return lrArray;
        },

        imgResultsRows: function () {
            let lrArray = [];
            let self = this;
            _.forEach(self.mResultatsImagerie, function (resultat) {
                lrArray.push({
                    description: resultat.description,
                    date: resultat.date,
                    slug: resultat.slug,
                    passedAt: resultat.passed_at,
                    archievedAt: resultat.archived_at
                })
            })
            let sArray = lrArray;
            lrArray = self.filterResult(sArray, lrArray);
            return lrArray;
        },

        hospitalisationsRows: function () {
            let hArray = [];
            let self = this;
            _.forEach(self.mHospitalisations, function (hospitalisation) {
                let motifs = "";
                _.forEach(hospitalisation.motifs, function (motif, key) {
                    motifs = motifs + (key != 0 ? " ," : "") + motif.description;
                })
                hArray.push({
                    date_entree: hospitalisation.date_entree,
                    date_sortie: hospitalisation.date_sortie,
                    traitement: hospitalisation.traitement_sortie,
                    motifs: motifs,
                    slug: hospitalisation.slug,
                    consultant: self.formatFullName(hospitalisation.author),
                    passedAt: hospitalisation.passed_at,
                    archievedAt: hospitalisation.archived_at
                })
            });
            let sArray = hArray;
            hArray = self.filterResult(sArray, hArray);
            return hArray;
        },

        mMedicalAdvices: function () {
            let patientMedicalAdvices = this.medicalAdvices.filter(medicalAdvice => medicalAdvice.dossier.patient_id === this.file.patient_id);

            //console.log('a patientMedicalAdvices => ', patientMedicalAdvices);

            patientMedicalAdvices = patientMedicalAdvices.map(p => {
                return {
                    ...p,
                    medecin_avis: p.medecin_avis.filter(doctorAdvice => doctorAdvice.statut === 'VALIDE')
                }
            }).filter(p => p.medecin_avis.length > 0);

            //console.log('b patientMedicalAdvices => ', patientMedicalAdvices);

            return patientMedicalAdvices;
        }
    },

    data() {
        return {
          	form:{
              responsable: [],
            },
            referentDoctors: [],
            filtered: [{
                    id: 1,
                    text: 'Tous'
                },
                {
                    id: 2,
                    text: 'Non Archivés'
                },
                {
                    id: 3,
                    text: 'Non Transmis'
                },
                {
                    id: 4,
                    text: 'Archivés'
                },
                {
                    id: 5,
                    text: 'Transmis'
                },
            ],
            show:false,
            filteredValue: null,
            file_id: this.$route.params.file,
            prescriptionsColumns: [{
                label: this.$i18n.t('message.prescriptionDate'),
                field: 'date_prescription',
                type: 'date',
                dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
                dateOutputFormat: 'dd/MM/yyyy',
            }, ],
            allergiesColumns: [{
                    label: 'Description',
                    field: 'description',
                },
               
            ],

            labResultsColumns: [{
                    label: 'Description',
                    field: 'description',
                },
                {
                    label: this.$i18n.t('message.date'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],

            imgResultsColumns: [{
                    label: 'Description',
                    field: 'description',
                },
                {
                    label: this.$i18n.t('message.date'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],

            antecedentsColumns: [{
                    label: this.$i18n.tc('message.types', 1),
                    field: 'type',
                },
                {
                    label: 'Description',
                    field: 'description',
                    html: true,
                },
                {
                    label: this.$i18n.t('message.startDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],

            manuscritColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'praticien',
                },
                {
                    label: this.$i18n.tc('message.types', 1),
                    field: 'type',
                },
                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],

            comptesRenduOpColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.t('message.typeIntervention'),
                    field: 'type',
                },
                {
                    label: this.$i18n.t('message.dateIntervention'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd HH:mm',
                    dateOutputFormat: 'dd/MM/yyyy HH:mm',
                },
            ],

            medecinesColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },

                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },

                {
                    label: this.$i18n.t('message.conclusion'),
                    field: 'conclusions',
                    html: true
                },
                {
                    label: this.$i18n.t('message.suggestTreatment'),
                    field: 'traitement',
                    html: true
                },
            ],
            cardiologiesColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },

                {
                    label: this.$i18n.t('message.conclusion'),
                    field: 'conclusions',
                    html: true
                },
            ],
            kinesitherapiesColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },

                {
                    label: this.$i18n.t('message.conclusion'),
                    field: 'conclusions',
                    html: true
                },
            ],
            hospitalisationsColumns: [{
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.entryDate'),
                    field: 'date_entree',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },

                {
                    label: this.$i18n.t('message.exitDate'),
                    field: 'date_sortie',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },

                {
                    label: this.$i18n.t('message.exitTreatment'),
                    field: 'traitement',
                    html: true
                },
            ],

            obstetricsColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.pregnancyNumber'),
                    field: 'numero',
                    type: 'number',
                },
                {
                    label: this.$i18n.t('message.ddr'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.t('message.serology'),
                    field: 'serologie',
                },
                {
                    label: this.$i18n.t('message.bloodGroup'),
                    field: 'groupe',
                },
            ],

            traitementsColumns: [{
                    label: 'Description',
                    field: 'description',
                },
            ],

            echograhiesColumns: [{
                    label: this.$i18n.tc('message.types', 2),
                    field: 'type',
                },
                {
                    label: this.$i18n.t('message.ddr'),
                    field: 'ddr',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.t('message.dpa'),
                    field: 'dpa',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.t('message.amenorrheaWeek'),
                    field: 'semaine_amenorrhee',
                },

            ],

            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
            
        }
    },

    watch: {
        /*file: function (n, o) {
            //console.log('n => ', n);
        }*/
    },

    methods: {
        displayDate(date) {
            return moment(date).format("dddd, MMMM Do YYYY, h:mm:ss a");
        },
        filterResult(sArray, mArray) {
            if (this.filteredValue == 1) {
                mArray = sArray;
            } else if (this.filteredValue == 2) {
                //Non archivés
                mArray = _.filter(mArray, function (medecine) {
                    return _.isNull(medecine.archievedAt);
                })
            } else if (this.filteredValue == 3) {
                //Non transmis
                mArray = _.filter(mArray, function (medecine) {
                    return _.isNull(medecine.passedAt);
                })
            } else if (this.filteredValue == 4) {
                //Archivés
                mArray = _.filter(mArray, function (medecine) {
                    return !_.isNull(medecine.archievedAt);
                })
            } else if (this.filteredValue == 5) {
                //Transmis
                mArray = _.filter(mArray, function (medecine) {
                    return !_.isNull(medecine.passedAt);
                })
            }
            return mArray;
        },
        formatFullName(author) {
            if (!_.isNull(author) && !_.isUndefined(author)) {
                if (author.hasOwnProperty('user')) {
                    let user = author.user
                    if (!_.isUndefined(user) && !_.isNull(user)) {
                        let prenom = (user.prenom == null) ? '' : user.prenom;
                        return (user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    }
                } else {
                    if (!_.isUndefined(author) && !_.isNull(author)) {
                        let prenom = (author.prenom == null) ? '' : author.prenom;
                        return (author.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    }
                }
            }
            return "";
        },

        ImprimerDossier() {
            let args = {
                dossier: this.file_id
            };

            this.$store.dispatch("printMedicalFile", {
                args
            });
            // return (this.$router.resolve({ name: 'medical-file',  params: { file: this.file.slug } })).href;

        },

        onPrescriptionRowClick(params) {
            this.$router.push({
                name: 'prescription',
                params: {
                    prescription: params.row.slug
                }
            });
        },

        onHospitalisationRowClick(params) {
            this.$router.push({
                name: 'hospitalisation',
                params: {
                    hospitalisation: params.row.slug
                }
            });
        },

        onImgResultRowClick(params) {
            this.$router.push({
                name: 'imagery-result',
                params: {
                    result: params.row.slug
                }
            });
        },

        onLabResultRowClick(params) {
            this.$router.push({
                name: 'lab-result',
                params: {
                    result: params.row.slug
                }
            });
        },

        onEchographieRowClick(params) {
            this.$router.push({
                name: 'ultrasound',
                params: {
                    ultrasound: params.row.slug
                }
            });
        },

        onTraitementRowClick(params) {
            this.$router.push({
                name: 'treatment',
                params: {
                    treatment: params.row.slug
                }
            });
        },

        onManuscritRowClick(params) {
            this.$router.push({
                name: 'consultation-manuscrit',
                params: {
                    consultation: params.row.slug
                }
            });
        },

        onComptesRenduOpRowClick(params) {
            this.$router.push({
                name: 'compte-rendu',
                params: {
                    compteRendu: params.row.slug
                }
            });
        },

        onMedecineRowClick(params) {
            this.$router.push({
                name: 'consultation-general',
                params: {
                    consultation: params.row.slug
                }
            });
        },

        onCardiologyRowClick(params) {
            this.$router.push({
                name: 'consultation-cardiology',
                params: {
                    consultation: params.row.slug
                }
            });
        },
        onkinesitherapyRowClick(params) {
            //console.log(params);
            this.$router.push({
                name: 'consultation-kinesitherapie',
                params: {
                    kinesitherapie: params.row.slug
                }
            });
        },
        onObsteticRowClick(params) {
            this.$router.push({
                name: 'consultation-obstetric',
                params: {
                    consultation: params.row.slug
                }
            });
        },

        onAntecedentRowClick(params) {
            if (params.row.hasOwnProperty('medecine')) {
                this.$router.push({
                    name: 'consultation-general',
                    params: {
                        consultation: params.row.medecine
                    }
                });
            } else if (params.row.hasOwnProperty('cardiology')) {
                this.$router.push({
                    name: 'consultation-cardiology',
                    params: {
                        consultation: params.row.cardiology
                    }
                });
            } else {
                this.$router.push({
                    name: 'antecedent',
                    params: {
                        antecedent: params.row.slug,
                        file: this.file_id
                    }
                });
            }
        },

        onAllergieRowClick(params) {
            this.$router.push({
                name: 'allergy',
                params: {
                    allergy: params.row.slug
                }
            });
        },

        notEmpty(item) {
            return item.length > 0;
        },

        getMedicalValue(item) {
            return this.mMedicalFile.hasOwnProperty(item) ? this.mMedicalFile[item] : "";
        },

        getUserValue(item) {
            if (this.mMedicalFile.hasOwnProperty('patient')) {
                if (this.mMedicalFile.patient.hasOwnProperty('user')) {
                    return this.mMedicalFile.patient.user[item];
                }
                return "";
            }
            return "";
        },

        getSouscripteurValue(item) {
            if (this.mMedicalFile.hasOwnProperty('patient')) {
                if (this.mMedicalFile.patient.hasOwnProperty('souscripteur')) {
                    if (!_.isNull(this.mMedicalFile.patient.souscripteur)) {
                        return this.mMedicalFile.patient.souscripteur.user[item] !== null ? this.mMedicalFile.patient.souscripteur.user[item]:"";
                    }
                }
                return "";
            }
            return "";
        },

        toAllergie() {
            this.$router.push({
                name: 'add-allergy',
                params: {
                    file: this.file_id
                }
            })
        },

        toAntecedent() {
            this.$router.push({
                name: 'add-antecedent',
                params: {
                    file: this.file_id
                }
            })
        },

        toManuscrit() {
            this.$router.push({
                name: 'add-consultation-manuscrit',
                params: {
                    file: this.file_id
                }
            })
        },

        toCompteRendu() {
            this.$router.push({
                name: 'add-compte-rendu',
                params: {
                    file: this.file_id
                }
            })
        },

        toCurrentTraitement() {
            this.$router.push({
                name: 'add-treatments',
                params: {
                    file: this.file_id
                }
            })
        },

        getMedicalFile() {
            let args = {
                file: this.file_id
            };

            this.$store.dispatch("getMedicalFile", {
                args
            });
        },

        updateMedicalFile() {
            this.$router.push({
                name: 'edit-medical-file',
                params: {
                    file: this.file_id
                }
            });
        },
        showAdd(){
         // this.show = true;
        },
        deleteMedicalFile() {
            let self = this;
            let args = {
                file: this.file_id
            };

            let successMessage = this.$i18n.t('message.medicalFileDeleted');
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.error')
            };

            this.$store.dispatch('deleteMedicalFile', {
                args,
                index: self.file_id,
                successMessage,
                errorMessages
            }).then(() => {
                self.$bvModal.hide('delete-modal');
                this.$router.back();

            });
        },

        pathHas(element) {
            let result = (this.$route.fullPath).includes(element);
            if (result) {
                if ($('#' + element).length) {
                    document.getElementById(element).scrollIntoView(top);
                }
            }

            return result;
        },

        getListOfMedicalAdvices() {
            if (!this.hasPatientRole && !this.hasSouscripteurRole && this.can) {
                this.$store.dispatch('getMedicalAdvices', {
                    args: {}
                });
            }
        },
        getDoctors() {
          let args = {
            offset: this.offset,
            limit: this.limit
          };

          this.$store.dispatch('getControlDoctors', { args : args });
			},

			errorshasField(field) {
				return this.errors ? this.errors.hasOwnProperty(field) : false;
			},

			clearErrorField(field) {
				this.$store.dispatch('clearErrorField', {field});

				this.errorshasField(field);
			},
      removeReferent(item){
            let self = this;
            let args = {
                slug: item.id
            };

            let successMessage = this.$i18n.t('supprimé');
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.error')
            };
            //this.mReferentDoctors = this.mReferentDoctors;
            this.$store.dispatch('deleteMedecinPatient', {
                args,
                successMessage,
                errorMessages
            }).then(() => {
            self.$bvModal.hide('delete-modal');               
             this.getMedicalFile();
            });
      },
      onAddReferent() {

        event.preventDefault();
				this.$v.$touch();

				if (!this.$v.$invalid ) {
					const args = {};
                let self = this;
                            args.medecin_control_id = this.form.responsable.map(r => ({id: r}));
                args.patient_id = this.mMedicalFile.patient.user_id;

					const successMessage = this.$i18n.t('message.followedUpCreated');
					const errorMessages = {
						generic: this.$i18n.t('message.genericError'),
						error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
					};

          
					const payload = { args, errorMessages, successMessage };

					this.$store.dispatch("addDoctorToPatient", payload).then(() => {
                       this.getMedicalFile();
                    });
				}
                
      },


    },
		validations() {
			return {
				form: {

					responsable:{

					},
				}
			}
		},
    mounted() {
        localStorage.setItem('reload', 0);
        this.getMedicalFile();

        if (this.can) {
            this.getListOfMedicalAdvices();
        }

        // Fetch control doctor list
		this.getDoctors();

        new SlimSelect({
          select: '#responsable',
          placeholder: 'Select manager',
          // limit: 1
        });

        new SlimSelect({
            select: '#singleMotif',
            placeholder: 'Select',
        });

    }
}
</script>

<style lang="scss" scoped>

</style>
